export default __webpack_public_path__ + "static/media/Visual_joil_20.fe1b6065.jpg";